import { enUS, es } from 'date-fns/locale'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { I18N_DEBUG } from '../../constants/config'
import { isWeb } from '../../util/platform'

import { supportedLocales } from './supportedLocales'
import { SupportedLanguageKeys } from './types'

i18n.use(initReactI18next).init({
  lng: SupportedLanguageKeys.ES_ES,
  compatibilityJSON: 'v3',
  fallbackLng: !I18N_DEBUG ? SupportedLanguageKeys.ES_ES : false,
  pluralSeparator: '_',
  debug: I18N_DEBUG,
  resources: supportedLocales,
  defaultNS: 'translations',
  nonExplicitSupportedLngs: true,
  missingKeyNoValueFallbackToKey: I18N_DEBUG,
  react: {
    bindI18n: 'languageChanged loaded',
    bindI18nStore: 'added removed',
  },
  interpolation: {
    escapeValue: false,
  },
})

i18n.on('languageChanged', lng => {
  if (isWeb()) {
    document.documentElement.setAttribute('lang', lng)
  }
})

const dateLocales: Record<string, Locale> = {
  en: enUS,
  es: es,
  'en-US': enUS,
  'es-ES': es,
}

export function getDateLocale(): Locale {
  return dateLocales[i18n.language]
}

export default i18n
